<template>
    <component :is="tag" class="lazy-background" :style="{ backgroundImage: `url(${ src })` }">
        <slot />
    </component>
</template>

<script>
    export default {
        name: 'lazy-background',

        props: {
            tag: {
                type: String,
                default: 'div',
            },

            src: {
                type: String,
                default: '',
                required: true,
            },
        },
    };
</script>
